import { marked } from 'marked'
import classNames from 'classnames'

import HtmlContent from '../ui/HtmlContent/HtmlContent'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import { isArabic } from '../../utils'
import styles from './Markdown.module.scss'

function Markdown({ content = '', className }) {
  const { language } = useLanguage()
  return (
    <HtmlContent
      content={marked(content || '')}
      contentClass={classNames(styles.markdown, className, {
        [styles.arabicMarkdown]: isArabic(language?.code),
      })}
    />
  )
}

export default Markdown
